
if (window.innerWidth > 768) {
  let observerAttached = false;

  document
    .querySelector(".wizzy-search-input")
    .addEventListener("click", function () {
      const searchPopdown = document.querySelector(
        ".header__desktop__button header-search-popdown"
      );

      if (!searchPopdown) return;

      const toggleAutocompleteVisibility = () => {
        const autocompleteWrapper = document.querySelector(
          ".wizzy-autocomplete-wrapper.onLeft"
        );

        if (!autocompleteWrapper) return;

        if (!searchPopdown.classList.contains("is-open")) {
          autocompleteWrapper.style.setProperty("display", "none");
        }
      };

      const waitForAutocomplete = () => {
        const autocompleteWrapper = document.querySelector(
          ".wizzy-autocomplete-wrapper.onLeft"
        );

        if (!autocompleteWrapper) {
          setTimeout(waitForAutocomplete, 200);
          return;
        }

        toggleAutocompleteVisibility();

        if (!observerAttached) {
          const observer = new MutationObserver(() => {
            toggleAutocompleteVisibility();
          });

          observer.observe(searchPopdown, {
            attributes: true,
            attributeFilter: ["class"],
          });

          observerAttached = true;
        }
      };

      waitForAutocomplete();
    });
}
if (window.innerWidth < 768) {
  let observerAttached = false;

  document
    .querySelector(".wizzy-search-input")
    .addEventListener("click", function () {
      const searchPopdown = document.querySelector(
        ".header__mobile__button header-search-popdown"
      );

      if (!searchPopdown) return;

      const toggleAutocompleteVisibility = () => {
        const autocompleteWrapper = document.querySelector(
          ".wizzy-autocomplete-wrapper.onLeft"
        );

        if (!autocompleteWrapper) return;

        if (!searchPopdown.classList.contains("is-open")) {
          autocompleteWrapper.style.setProperty("display", "none");
        }
      };

      const waitForAutocomplete = () => {
        const autocompleteWrapper = document.querySelector(
          ".wizzy-autocomplete-wrapper.onLeft"
        );

        if (!autocompleteWrapper) {
          setTimeout(waitForAutocomplete, 200);
          return;
        }

        toggleAutocompleteVisibility();

        if (!observerAttached) {
          const observer = new MutationObserver(() => {
            toggleAutocompleteVisibility();
          });

          observer.observe(searchPopdown, {
            attributes: true,
            attributeFilter: ["class"],
          });

          observerAttached = true;
        }
      };

      waitForAutocomplete();
    });
}

let wizzyEvents = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      document.querySelector(".search-popdown__close__button").click();
      return data;
    }
  );
  //  window.wizzyConfig.events.registerEvent(
  //   window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED,
  //   function (data) {
  //     document.querySelectorAll('.wizzy-product-item-price').forEach(priceContainer => {
  //     priceContainer.querySelectorAll('span').forEach(span => {
  //       console.log(span.textContent);
  //       span.textContent = span.textContent.replace('.00', '');
  //     });
  //     priceContainer.childNodes.forEach(node => {
  //       if (node.nodeType === Node.TEXT_NODE) {
  //         node.textContent = node.textContent.replace('.00', '');
  //         console.log(node.textContent);
  //       }
  //     });
  //   });
  //     return data;
  //   }
  // );
  
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (productsList) {
      productsList.forEach((product) => {
        // Remove decimal part from prices
        if (
          typeof product.price !== "undefined" &&
          product.price &&
          product.price.toString().includes(".")
        ) {
          product.price = product.price.toString().split(".")[0];
        }

        if (
          typeof product.sellingPrice !== "undefined" &&
          product.sellingPrice &&
          product.sellingPrice.toString().includes(".")
        ) {
          product.sellingPrice = product.sellingPrice.toString().split(".")[0];
        }

        // Default value
        product.productWeight = "";

        //Process attributes
        product.attributes.forEach((attribute) => {
          if (attribute.id === "product_short_description_plp_custom") {
            product.short_description = attribute.values[0].value;
          }

          if (attribute.id === "product_weight_custom") {
            product.productWeight = attribute.values[0].value[0];
          }
          if (attribute.id === "product_stars_product_opinew_metafields") {
            product.opiNewTag = attribute.values[0].value[0];
          }
          if (attribute.id === "product_short_ingredient_custom") {
            product.shortIngrediant = attribute.values[0].value[0];
          }
          if (attribute.id === "product_reviews_average_opinew_metafields") {
            product.opiNewAverageReviews = attribute.values[0].value[0];
          }
        });
      });

      return productsList;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_PRODUCTS_RENDER,
    function (data) {
      console.log(data);
      const desktopInput = document.getElementById("SearchInput--desktop");
      const mobileInput = document.getElementById("SearchInput--mobile");

      const SearchValue = window.wizzyConfig.pageStore.searchInputValue || "";
      if (SearchValue) {
        data.searchQuery = SearchValue;
      }

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      let mapper = {};
      let cart_items = document.querySelectorAll(".drawer__inner .drawer__body .cart__item");
      cart_items.forEach((item) => {
        let value = item.querySelector(".cart__quantity-field").value;
        let id = item.querySelector(".cart__quantity-field").dataset.productitemId;
        console.log("ID : ", id);
        console.log("VALUE : ", value);
        mapper[id] = value;
        // console.log("Value:", value);
      });

      let products = document.querySelectorAll('.wizzy-result-product');
      products.forEach((product) => {
        let id = product.dataset.id;
         if (mapper.hasOwnProperty(id)) {
           let add_to_cart_button = product.querySelector('.add-to-cart-btn');
           add_to_cart_button.style.setProperty("display", "none", "important");
           let quantity_wrapper = product.querySelector(".quantity-wrapper");
           quantity_wrapper.style.setProperty("display", "flex", "important");
           let cart_quantity = quantity_wrapper.querySelector(".cart-quantity");
                 cart_quantity.textContent = mapper[id];
         }
      })

      
      
      
      document.querySelectorAll('.wizzy-product-item-price').forEach(priceContainer => {
      priceContainer.querySelectorAll('span').forEach(span => {
        console.log(span.textContent);
        span.textContent = span.textContent.replace('.00', '');
      });
      priceContainer.childNodes.forEach(node => {
        if (node.nodeType === Node.TEXT_NODE) {
          node.textContent = node.textContent.replace('.00', '');
          console.log(node.textContent);
        }
      });
    });
      document.querySelectorAll(".add-to-cart-btn").forEach((button) => {
        button.addEventListener("click", (e) => {
          const qty = button.getAttribute("data-quantity") || "1";
          checkCartLimits(qty).then((cart) => {
            if (!cart) return;
            const formData = new FormData();
            const variantId = button.getAttribute("data-variant-id");
            const productId = button.getAttribute("data-product-id");
            formData.append("id", variantId);
            formData.append("form_type", "product");
            formData.append("utf8", "✓");
            formData.append("quantity", qty);
            if (productId) formData.append("product-id", productId);
            formData.append("section-id", "template--17632417120300__main");
            const addToCartEvent = new CustomEvent("theme:cart:add", {
              detail: { button, formData },
              bubbles: false,
            });
            document.dispatchEvent(addToCartEvent);
            setTimeout(()=>{
              let mapper = {};
            let cart_items = document.querySelectorAll(".drawer__inner .drawer__body .cart__item");
            cart_items.forEach((item) => {
              let value = item.querySelector(".cart__quantity-field").value;
              let id = item.querySelector(".cart__quantity-field").dataset.productitemId;
              console.log("ID : ", id);
              console.log("VALUE : ", value);
              mapper[id] = value;
              // console.log("Value:", value);
            });
      
            let products = document.querySelectorAll('.wizzy-result-product');
            products.forEach((product) => {
              let id = product.dataset.id;
               if (mapper.hasOwnProperty(id)) {
                 let add_to_cart_button = product.querySelector('.add-to-cart-btn');
                 add_to_cart_button.style.setProperty("display", "none", "important");
                 let quantity_wrapper = product.querySelector(".quantity-wrapper");
                 quantity_wrapper.style.setProperty("display", "flex", "important");
                 let cart_quantity = quantity_wrapper.querySelector(".cart-quantity");
                 cart_quantity.textContent = mapper[id];
               }
              else
               {
                 let add_to_cart_button = product.querySelector('.add-to-cart-btn');
                 add_to_cart_button.style.setProperty("display", "block", "important");
                 let quantity_wrapper = product.querySelector(".quantity-wrapper");
                 quantity_wrapper.style.setProperty("display", "none", "important");
               }
            })
            }, 1500);
          });
        });
      });

      document.addEventListener("theme:product:add", (event) => {
        const button = event.detail.button;
        if (!button) return;
        button.classList.add("hide-atc_btn");
        const atcParentElement = button.parentElement.parentElement;
        if (atcParentElement.classList.contains("upsell-product")) {
          const upsellCarousel = atcParentElement.closest(".upsell-products");

          if (upsellCarousel) {
            const flktyInstance = Flickity.data(upsellCarousel);
            if (flktyInstance) {
              atcParentElement.remove(); // Remove the upsell product card
              flktyInstance.reloadCells(); // Update Flickity layout
              flktyInstance.resize(); // Ensure correct resizing
            }
          }
        }

        const qtyWrapper =
          button.parentElement.querySelector(".quantity-wrapper");
        if (qtyWrapper) {
          qtyWrapper.classList.add("active-qty");
          const variantId = button.getAttribute("data-variant-id");
          // Fetch latest cart data to update quantity
          checkCartLimits().then((cart) => {
            if (cart && cart.items) {
              const cartItem = cart.items.find((item) => item.id == variantId);
              if (cartItem) {
                const cartQuantityElem =
                  qtyWrapper.querySelector(".cart-quantity");
                const productQuantityInc =
                  qtyWrapper.querySelector(".increase-cart-qty");
                const productQuantityDec =
                  qtyWrapper.querySelector(".decrease-cart-qty");

                if (cartQuantityElem) {
                  cartQuantityElem.textContent = cartItem.quantity;
                  qtyWrapper.setAttribute("data-key", cartItem.key);
                }
                if (productQuantityInc) {
                  productQuantityInc.setAttribute("data-key", cartItem.key);
                }
                if (productQuantityDec) {
                  productQuantityDec.setAttribute("data-key", cartItem.key);
                }
              }
            }
          });
        }
      });

      document.querySelectorAll(".quantity-wrapper").forEach((wrapper) => {
        const decreaseBtn = wrapper.querySelector(".decrease-cart-qty");
        const increaseBtn = wrapper.querySelector(".increase-cart-qty");
        if (decreaseBtn) {
          decreaseBtn.addEventListener("click", (event) => {
            const itemCartKey = event.target.getAttribute("data-variant-id");
            // Remove disabled attribute from increase button if present
            increaseBtn?.removeAttribute("disabled");
            const cartQuantity = document.querySelector(
              `.cart__quantity-minus[data-productitem-id="${itemCartKey}"]`
            );
            if (cartQuantity) {
              cartQuantity.click();
            } else {
              event.target
                .closest(".quantity-wrapper")
                ?.classList.remove("active-qty");
              const parentElement =
                event.target.closest(".quantity-wrapper")?.parentElement
                  ?.parentElement;
              if (parentElement) {
                parentElement
                  .querySelector(".add-to-cart-btn")
                  .classList.remove("hide-atc_btn");
              }
            }
            setTimeout(()=>{
              let mapper = {};
            let cart_items = document.querySelectorAll(".drawer__inner .drawer__body .cart__item");
            cart_items.forEach((item) => {
              let value = item.querySelector(".cart__quantity-field").value;
              let id = item.querySelector(".cart__quantity-field").dataset.productitemId;
              console.log("ID : ", id);
              console.log("VALUE : ", value);
              mapper[id] = value;
              // console.log("Value:", value);
            });
      
            let products = document.querySelectorAll('.wizzy-result-product');
            products.forEach((product) => {
              let id = product.dataset.id;
               if (mapper.hasOwnProperty(id)) {
                 let add_to_cart_button = product.querySelector('.add-to-cart-btn');
                 add_to_cart_button.style.setProperty("display", "none", "important");
                 let quantity_wrapper = product.querySelector(".quantity-wrapper");
                 quantity_wrapper.style.setProperty("display", "flex", "important");
                 let cart_quantity = quantity_wrapper.querySelector(".cart-quantity");
                 cart_quantity.textContent = mapper[id];
               }
              else
               {
                 let add_to_cart_button = product.querySelector('.add-to-cart-btn');
                 add_to_cart_button.style.setProperty("display", "block", "important");
                 let quantity_wrapper = product.querySelector(".quantity-wrapper");
                 quantity_wrapper.style.setProperty("display", "none", "important");
               }
            })
            }, 3000);
            
          });
        }
        if (increaseBtn) {
          increaseBtn.addEventListener("click", (event) => {
            const itemCartKey = event.target.getAttribute("data-variant-id");
            const cartQuantity = document.querySelector(
              `.cart__quantity-plus[data-productitem-id="${itemCartKey}"]`
            );
            if (cartQuantity) {
              cartQuantity.click();
            }
            let mapper = {};
            let cart_items = document.querySelectorAll(".drawer__inner .drawer__body .cart__item");
            cart_items.forEach((item) => {
              let value = item.querySelector(".cart__quantity-field").value;
              let id = item.querySelector(".cart__quantity-field").dataset.productitemId;
              console.log("ID : ", id);
              console.log("VALUE : ", value);
              mapper[id] = value;
              // console.log("Value:", value);
            });
      
            let products = document.querySelectorAll('.wizzy-result-product');
            products.forEach((product) => {
              let id = product.dataset.id;
               if (mapper.hasOwnProperty(id)) {
                 let add_to_cart_button = product.querySelector('.add-to-cart-btn');
                 add_to_cart_button.style.setProperty("display", "none", "important");
                 let quantity_wrapper = product.querySelector(".quantity-wrapper");
                 quantity_wrapper.style.setProperty("display", "flex", "important");
                 let cart_quantity = quantity_wrapper.querySelector(".cart-quantity");
                 cart_quantity.textContent = mapper[id];
               }
              else
               {
                 let add_to_cart_button = product.querySelector('.add-to-cart-btn');
                 add_to_cart_button.style.setProperty("display", "block", "important");
                 let quantity_wrapper = product.querySelector(".quantity-wrapper");
                 quantity_wrapper.style.setProperty("display", "none", "important");
               }
            })
          });
        }
      });

      mapper = {};
          cart_items = document.querySelectorAll(".drawer__inner .drawer__body .cart__item");
            cart_items.forEach((item) => {
              let value = item.querySelector(".cart__quantity-field").value;
              let id = item.querySelector(".cart__quantity-field").dataset.productitemId;
              console.log("ID : ", id);
              console.log("VALUE : ", value);
              mapper[id] = value;
              // console.log("Value:", value);
            });
      
            products = document.querySelectorAll('.wizzy-result-product');
            products.forEach((product) => {
              let id = product.dataset.id;
               if (mapper.hasOwnProperty(id)) {
                 let add_to_cart_button = product.querySelector('.add-to-cart-btn');
                 add_to_cart_button.style.setProperty("display", "none", "important");
                 let quantity_wrapper = product.querySelector(".quantity-wrapper");
                 quantity_wrapper.style.setProperty("display", "flex", "important");
                 let cart_quantity = quantity_wrapper.querySelector(".cart-quantity");
                 cart_quantity.textContent = mapper[id];
               }
              else
               {
                 let add_to_cart_button = product.querySelector('.add-to-cart-btn');
                 add_to_cart_button.style.setProperty("display", "block", "important");
                 let quantity_wrapper = product.querySelector(".quantity-wrapper");
                 quantity_wrapper.style.setProperty("display", "none", "important");
               }
            })

      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents
      .BEFORE_AUTOCOMPLETE_SUGGESTIONS_RENDER,
    function (data) {
      setTimeout(() => {
        const headItem = document.querySelector(
          '.autocomplete-item-head[data-index="0"]'
        );
        if (headItem) {
          headItem.innerHTML = "Top Categories";
        }
      }, 0);
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      return data;
    }
  );
};
let desktop_search_bar = document.querySelector('#wizzy-search-input-desktop');
if(desktop_search_bar)
{
  desktop_search_bar.addEventListener("click", function(){
    setTimeout(()=>{
      document.querySelectorAll(".add-to-cart-btn").forEach((button) => {
        button.addEventListener("click", (e) => {
          const qty = button.getAttribute("data-quantity") || "1";
          checkCartLimits(qty).then((cart) => {
            if (!cart) return;
            const formData = new FormData();
            const variantId = button.getAttribute("data-variant-id");
            const productId = button.getAttribute("data-product-id");
            formData.append("id", variantId);
            formData.append("form_type", "product");
            formData.append("utf8", "✓");
            formData.append("quantity", qty);
            if (productId) formData.append("product-id", productId);
            formData.append("section-id", "template--17632417120300__main");
            const addToCartEvent = new CustomEvent("theme:cart:add", {
              detail: { button, formData },
              bubbles: false,
            });
            document.dispatchEvent(addToCartEvent);
          });
        });
      });

      document.addEventListener("theme:product:add", (event) => {
        const button = event.detail.button;
        if (!button) return;
        button.classList.add("hide-atc_btn");
        const atcParentElement = button.parentElement.parentElement;
        if (atcParentElement.classList.contains("upsell-product")) {
          const upsellCarousel = atcParentElement.closest(".upsell-products");

          if (upsellCarousel) {
            const flktyInstance = Flickity.data(upsellCarousel);
            if (flktyInstance) {
              atcParentElement.remove(); // Remove the upsell product card
              flktyInstance.reloadCells(); // Update Flickity layout
              flktyInstance.resize(); // Ensure correct resizing
            }
          }
        }

        const qtyWrapper =
          button.parentElement.querySelector(".quantity-wrapper");
        if (qtyWrapper) {
          qtyWrapper.classList.add("active-qty");
          const variantId = button.getAttribute("data-variant-id");
          // Fetch latest cart data to update quantity
          checkCartLimits().then((cart) => {
            if (cart && cart.items) {
              const cartItem = cart.items.find((item) => item.id == variantId);
              if (cartItem) {
                const cartQuantityElem =
                  qtyWrapper.querySelector(".cart-quantity");
                const productQuantityInc =
                  qtyWrapper.querySelector(".increase-cart-qty");
                const productQuantityDec =
                  qtyWrapper.querySelector(".decrease-cart-qty");

                if (cartQuantityElem) {
                  cartQuantityElem.textContent = cartItem.quantity;
                  qtyWrapper.setAttribute("data-key", cartItem.key);
                }
                if (productQuantityInc) {
                  productQuantityInc.setAttribute("data-key", cartItem.key);
                }
                if (productQuantityDec) {
                  productQuantityDec.setAttribute("data-key", cartItem.key);
                }
              }
            }
          });
        }
      });

      document.querySelectorAll(".quantity-wrapper").forEach((wrapper) => {
        const decreaseBtn = wrapper.querySelector(".decrease-cart-qty");
        const increaseBtn = wrapper.querySelector(".increase-cart-qty");
        if (decreaseBtn) {
          decreaseBtn.addEventListener("click", (event) => {
            const itemCartKey = event.target.getAttribute("data-variant-id");
            // Remove disabled attribute from increase button if present
            increaseBtn?.removeAttribute("disabled");
            const cartQuantity = document.querySelector(
              `.cart__quantity-minus[data-productitem-id="${itemCartKey}"]`
            );
            if (cartQuantity) {
              cartQuantity.click();
            } else {
              event.target
                .closest(".quantity-wrapper")
                ?.classList.remove("active-qty");
              const parentElement =
                event.target.closest(".quantity-wrapper")?.parentElement
                  ?.parentElement;
              if (parentElement) {
                parentElement
                  .querySelector(".add-to-cart-btn")
                  .classList.remove("hide-atc_btn");
              }
            }
          });
        }
        if (increaseBtn) {
          increaseBtn.addEventListener("click", (event) => {
            const itemCartKey = event.target.getAttribute("data-variant-id");
            const cartQuantity = document.querySelector(
              `.cart__quantity-plus[data-productitem-id="${itemCartKey}"]`
            );
            if (cartQuantity) {
              cartQuantity.click();
            }
          });
        }
      });
    }, 300)
  })
}
if(window.innerWidth > 1165)
      {
        let header = document.querySelector('header-component');
        console.log(header);
        header.classList.remove('js__show__mobile');
      }
window.onWizzyLoaded.push(wizzyEvents);
